var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDheeanPukardian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87498 10.6875C7.87498 6.02759 11.6526 2.25 16.3125 2.25C20.9724 2.25 24.75 6.02759 24.75 10.6875C24.75 15.3474 20.9724 19.125 16.3125 19.125C14.3836 19.125 12.6059 18.4778 11.1847 17.3886L9.17346 19.3998L10.7771 21.0034C11.2164 21.4427 11.2164 22.1551 10.7771 22.5944C10.3377 23.0338 9.62542 23.0338 9.18607 22.5944L7.58247 20.9908L5.19784 23.3755C4.7585 23.8148 4.04619 23.8148 3.60685 23.3755C3.16751 22.9361 3.16751 22.2238 3.60685 21.7845L5.99147 19.3998L4.4131 17.8215C3.97376 17.3821 3.97376 16.6698 4.4131 16.2305C4.85245 15.7912 5.56475 15.7912 6.0041 16.2305L7.58247 17.8089L9.59607 15.7952C8.51616 14.3774 7.87498 12.6073 7.87498 10.6875ZM16.3125 4.5C12.8952 4.5 10.125 7.27023 10.125 10.6875C10.125 14.1048 12.8952 16.875 16.3125 16.875C19.7298 16.875 22.5 14.1048 22.5 10.6875C22.5 7.27023 19.7298 4.5 16.3125 4.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDheeanPukardian);
export default __webpack_public_path__ + "static/media/Dheean Pukardian.bee8c1fa661458c606d1aaf58f677a80.svg";
export { ForwardRef as ReactComponent };